import React from 'react';
import './index.scss';
import { showSignUpModal } from 'redux/actions/modalActions';
import { connect } from "react-redux";

function AboutUs({ showSignUpModal }) {
  const testimonials = [
    {
      quote: "PandaOnWheels has completely changed the way we cater for our office. The food is amazing and delivery is always on point.",
      author: "Ayesha Khan",
      role: "HR Manager, TechNova",
      avatar: "/assets/img/about/15.png"
    },
    {
      quote: "Our team looks forward to lunch every day! Great variety, great taste, and excellent service.",
      author: "Usman Ali",
      role: "Operations Lead, FinEdge",
      avatar: "/assets/img/about/16.png"
    },
    {
      quote: "Reliable, flexible and professional. The best catering partner we've worked with.",
      author: "Sara Malik",
      role: "Office Manager, CreativeLabs",
      avatar: "/assets/img/about/17.png"
    }
  ];

  return (
    <div className="pow-about-page">
      {/* SECTION 1: HERO (OUR STORY) */}
      <section className="pow-hero-section">
        <div className="pow-container pow-hero-grid">
          <div className="pow-hero-content">
            <span className="pow-sub-tag">OUR STORY</span>
            <h1 className="pow-hero-title">
              The Story<br />
              Behind the<br />
              <span className="pow-highlight-red">PandaOnWheels</span>
            </h1>
            <p className="pow-hero-desc">
              From a single delivery run to a corporate catering powerhouse, PandaOnWheels delivers speed with a smile.
            </p>

            <div className="pow-hero-pills">
              <div className="pow-pill-item">
                <img
                  src="/assets/img/about/01.png"
                  alt="Fresh & Hygienic"
                  className="pow-pill-img"
                />
                <span>Fresh &amp;<br />Hygienic</span>
              </div>

              <div className="pow-pill-item">
                <img
                  src="/assets/img/about/02.png"
                  alt="On-Time Delivery"
                  className="pow-pill-img"
                />
                <span>On-Time<br />Delivery</span>
              </div>

              <div className="pow-pill-item">
                <img
                  src="/assets/img/about/03.png"
                  alt="Loved by Teams"
                  className="pow-pill-img"
                />
                <span>Loved by<br />Teams</span>
              </div>

              <div className="pow-pill-item">
                <img
                  src="/assets/img/about/04.png"
                  alt="Custom Menus"
                  className="pow-pill-img"
                />
                <span>Custom<br />Menus</span>
              </div>
            </div>
          </div>

          <div className="pow-hero-media">
            <img
              src="/assets/img/about/22.png"
              alt="PandaOnWheels Scooter Delivery"
              className="pow-rounded-img"
            />
          </div>
        </div>
      </section>

      {/* SECTION 2: JOURNEY (OUR JOURNEY) */}
      <section className="pow-journey-section">
        <div className="pow-container pow-journey-grid">
          <div className="pow-journey-media">
            <img
              src="/assets/img/about/21.png"
              alt="Kitchen Team Preparing Catering"
              className="pow-rounded-img"
            />
          </div>

          <div className="pow-journey-content">
            <span className="pow-sub-tag">OUR JOURNEY</span>
            <h2 className="pow-section-title">
              Humble Beginnings,<br />
              Fast Growth
            </h2>
            <p>
              What started as a single ambitious rider navigating city streets to deliver hot meals has transformed into PandaOnWheels—a leader in corporate catering and rapid delivery.
            </p>
            <p>
              We built our foundation on reliability, ensuring that every meal arrives perfectly intact and right on time.
            </p>
            <p>
              Today, our fleet covers the entire metropolitan area, bringing top-tier culinary experiences directly to boardrooms and events, always maintaining that original fast-and-friendly spirit.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3: IMPACT IN NUMBERS */}
      <section className="pow-impact-section">
        <div className="pow-container">
          <div className="pow-text-center">
            <span className="pow-sub-tag">OUR IMPACT IN NUMBERS</span>
          </div>

          <div className="pow-impact-grid">
            {/* Card 1 */}
            <div className="pow-impact-card">
              <img src="/assets/img/about/07.png" alt="Happy Companies Served" className="pow-impact-icon-img" />
              <div className="pow-impact-num">850+</div>
              <div className="pow-impact-label">Happy Companies<br />Served</div>
            </div>

            {/* Card 2 */}
            <div className="pow-impact-card">
              <img src="/assets/img/about/08.png" alt="Cities We Serve" className="pow-impact-icon-img" />
              <div className="pow-impact-num">24</div>
              <div className="pow-impact-label">Cities<br />We Serve</div>
            </div>

            {/* Card 3 */}
            <div className="pow-impact-card">
              <img src="/assets/img/about/09.png" alt="Meals Delivered Every Day" className="pow-impact-icon-img" />
              <div className="pow-impact-num">5,000+</div>
              <div className="pow-impact-label">Meals Delivered<br />Every Day</div>
            </div>

            {/* Card 4 */}
            <div className="pow-impact-card">
              <img src="/assets/img/about/10.png" alt="On-Time Delivery Record" className="pow-impact-icon-img" />
              <div className="pow-impact-num">98%</div>
              <div className="pow-impact-label">On-Time Delivery<br />Record</div>
            </div>

            {/* Card 5 */}
            <div className="pow-impact-card">
              <img src="/assets/img/about/11.png" alt="Team Satisfaction Rate" className="pow-impact-icon-img" />
              <div className="pow-impact-num">95%</div>
              <div className="pow-impact-label">Team Satisfaction<br />Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: OUR MISSION */}
      <section className="pow-mission-section">
        <div className="pow-container pow-mission-grid">
          <div className="pow-mission-content">
            <span className="pow-sub-tag">OUR MISSION</span>
            <h2 className="pow-section-title">
              More Than Just Catering –<br />
              We're Your <span className="pow-highlight-red">Food Partner</span>
            </h2>
            <p className="pow-mission-sub">
              Our mission is to deliver delightful food experiences that fuel productivity, build connections, and make every workday better.
            </p>

            <div className="pow-mission-values-grid">
              {/* Quality First */}
              <div className="pow-value-item">
                <img src="/assets/img/about/11.png" alt="Quality First" className="pow-value-icon-img" />
                <div>
                  <h4>Quality First</h4>
                  <p>We never compromise on quality.</p>
                </div>
              </div>

              {/* Transparency */}
              <div className="pow-value-item">
                <img src="/assets/img/about/13.png" alt="Transparency" className="pow-value-icon-img" />
                <div>
                  <h4>Transparency</h4>
                  <p>Honest communication in everything we do.</p>
                </div>
              </div>

              {/* People-Centered */}
              <div className="pow-value-item">
                <img src="/assets/img/about/12.png" alt="People-Centered" className="pow-value-icon-img" />
                <div>
                  <h4>People-Centered</h4>
                  <p>We care for our team and your team.</p>
                </div>
              </div>

              {/* Sustainability */}
              <div className="pow-value-item">
                <img src="/assets/img/about/10.png" alt="Sustainability" className="pow-value-icon-img" />
                <div>
                  <h4>Sustainability</h4>
                  <p>Better for people, better for the planet.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="pow-mission-media-block">
            <img
              src="/assets/img/about/20.png"
              alt="Catering Food Feast Spread"
              className="pow-mission-img"
            />
            <div className="pow-quote-banner">
              <p>"Great food brings people together and powers great work."</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: HOW PANDAONWHEELS WORKS */}
      <section className="pow-works-section">
        <div className="pow-container">
          <div className="pow-text-center">
            <h2 className="pow-section-title">
              How <span className="pow-highlight-red">PandaOnWheels</span> Works
            </h2>
          </div>

          <div className="pow-steps-grid">
            {/* Step 1 */}
            <div className="pow-step-card">
              <img src="/assets/img/about/26.png" alt="Tell Us Your Needs" className="pow-step-icon-img" />
              <h3 className="pow-step-title">Tell Us Your Needs</h3>
              <p className="pow-step-desc">
                Share your team size, preferences, and delivery details.
              </p>
            </div>

            <div className="pow-step-arrow">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none">
                <path d="M0 8H42M42 8L35 1M42 8L35 15" stroke="#e52929" strokeWidth="1.5" strokeDasharray="3 3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* Step 2 */}
            <div className="pow-step-card">
              <img src="/assets/img/about/25.png" alt="Choose Your Menu" className="pow-step-icon-img" />
              <h3 className="pow-step-title">Choose Your Menu</h3>
              <p className="pow-step-desc">
                Pick from our wide range of delicious and healthy options.
              </p>
            </div>

            <div className="pow-step-arrow">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none">
                <path d="M0 8H42M42 8L35 1M42 8L35 15" stroke="#e52929" strokeWidth="1.5" strokeDasharray="3 3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* Step 3 */}
            <div className="pow-step-card">
              <img src="/assets/img/about/24.png" alt="We Prepare & Pack" className="pow-step-icon-img" />
              <h3 className="pow-step-title">We Prepare &amp; Pack</h3>
              <p className="pow-step-desc">
                Freshly cooked with premium ingredients and hygienic care.
              </p>
            </div>

            <div className="pow-step-arrow">
              <svg width="48" height="16" viewBox="0 0 48 16" fill="none">
                <path d="M0 8H42M42 8L35 1M42 8L35 15" stroke="#e52929" strokeWidth="1.5" strokeDasharray="3 3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* Step 4 */}
            <div className="pow-step-card">
              <img src="/assets/img/about/23.png" alt="Delivered On Time" className="pow-step-icon-img" />
              <h3 className="pow-step-title">Delivered On Time</h3>
              <p className="pow-step-desc">
                Right to your office, right on schedule, every time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: TESTIMONIALS */}
      <section className="pow-testimonials-section">
        <div className="pow-container">
          <div className="pow-text-center pow-mb-40">
            <span className="pow-pill-tag">LOVED BY TEAMS. TRUSTED BY COMPANIES.</span>
          </div>

          <div className="pow-testimonials-grid">
            {testimonials.map((t, idx) => (
              <div className="pow-testimonial-card" key={idx}>
                <div className="pow-quote-mark">“</div>
                <p className="pow-testimonial-quote">{t.quote}</p>
                <div className="pow-author-row">
                  <img
                    src={t.avatar}
                    alt={t.author}
                    className="pow-author-avatar"
                  />
                  <div>
                    <h5 className="pow-author-name">{t.author}</h5>
                    <span className="pow-author-role">{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="pow-carousel-dots">
            <span className="pow-dot active"></span>
            <span className="pow-dot"></span>
            <span className="pow-dot"></span>
          </div>
        </div>
      </section>

      {/* SECTION 7: CTA BANNER */}
      <section className="pow-cta-section">
        <div className="pow-container">
          <div className="pow-cta-banner">
            <div className="pow-cta-content">
              <h2 className="pow-cta-title">
                Ready to Make Lunch the<br />
                Best Part of the Day?
              </h2>
              <p className="pow-cta-subtitle">
                Join hundreds of happy teams enjoying great food every day.
              </p>

              <div className="pow-cta-actions">
                <button
                  className="pow-btn-white"
                  onClick={() => showSignUpModal()}
                >
                  Get a Quote
                </button>
                <button
                  className="pow-btn-outline"
                  onClick={() => showSignUpModal()}
                >
                  Explore Menus
                </button>
              </div>
            </div>

            <div className="pow-cta-media">
              <img
                src="/assets/img/about/27.png"
                alt="Delicious Food Platter with Iced Drink"
                className="pow-cta-img"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default connect(null, { showSignUpModal })(AboutUs);